import MarkdownParser from '../../utils/MarkdownParser';
import React from 'react';
export default function MarkdownRender(props: {md: string; className?: string; style?: React.CSSProperties}) {
  const html = MarkdownParser.render(props.md);
  return <div dangerouslySetInnerHTML={{__html: html}} className={'markdown-here-wrapper ' + props.className} style={{width: '100%', ...props.style}} />;
}
